// extracted by mini-css-extract-plugin
export default {"magazineContainer":"Gaudi_magazineContainer__B86kP","title":"Gaudi_title__d5jHo"};